import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";

export function buildCashOutTransactionId(prefix = "COP-TXN") {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export async function recordCashOutLedgerEntry(entry) {
  const doc = {
    transactionId: entry.transactionId,
    programId: entry.programId || null,
    userId: entry.userId || null,
    level: entry.level ?? null,
    amount: entry.amount,
    transactionType: entry.transactionType,
    fromWallet: entry.fromWallet || null,
    toWallet: entry.toWallet || null,
    matrixPositionId: entry.matrixPositionId || null,
    fillerUserId: entry.fillerUserId || null,
    status: entry.status || "COMPLETED",
    reference: entry.reference || null,
    metadata: entry.metadata || null,
    createdAt: serverTimestamp(),
  };
  await addDoc(collection(db, "cashOutLedger"), doc);
  return doc;
}
